// extracted by mini-css-extract-plugin
export default {"button":"AccountSocialItem_button__CN1se","disabled":"AccountSocialItem_disabled__rA60g","icon":"AccountSocialItem_icon__mVAQx"};